(() => {
  const modal = document.getElementById('BFNewsletter');
  if (!modal || typeof modal.showModal !== 'function' || modal.dataset.bound) return;
  modal.dataset.bound = 'true';
  const key = 'bf-newsletter-v1';
  let timer, lastFocus;
  const read = () => { try { return JSON.parse(localStorage.getItem(key) || '{}'); } catch (_) { return {}; } };
  const remember = state => { try { localStorage.setItem(key, JSON.stringify(state)); } catch (_) {} };
  const show = () => {
    if (modal.open) return;
    if (document.querySelector('dialog[open]')) { timer = setTimeout(show, 3000); return; }
    lastFocus = document.activeElement;
    modal.showModal();
    modal.querySelector('[data-bfn-close]').focus({preventScroll:true});
  };
  const hide = () => {
    clearTimeout(timer);
    if (modal.open) modal.close();
    const state = read();
    if (!state.subscribed) remember({closedAt:Date.now()});
    if (lastFocus?.isConnected) lastFocus.focus({preventScroll:true});
  };
  modal.querySelectorAll('[data-bfn-close]').forEach(button => button.addEventListener('click', hide));
  modal.addEventListener('cancel', event => { event.preventDefault(); hide(); });
  modal.addEventListener('click', event => { if(event.target === modal){const r=modal.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)hide();} });
  document.querySelectorAll('[data-bfn-open]').forEach(button => button.addEventListener('click', () => {clearTimeout(timer);show();}));
  // Shopify owns the customer-form submit cycle, including its captcha callbacks.
  // Do not cancel a second submit event or disable the native submit control.
  const success=modal.querySelector('[data-bfn-success]');
  const errors=modal.querySelector('[data-bfn-errors]');
  if (success && location.hash === '#BFNewsletterForm') {remember({subscribed:true});show();return;}
  if(errors){show();return;}
  const state=read();
  if(state.subscribed || Date.now()-Number(state.closedAt||0)<Number(modal.dataset.days)*86400000)return;
  if(new URLSearchParams(location.search).has('bf_newsletter_preview')){show();return;}
  timer=setTimeout(show, Number(modal.dataset.delay)*1000);
})();
